// extracted by mini-css-extract-plugin
export default {"wrapper":"NM-z","availablePromoMessagesLabel":"OM-z","promoMessageList":"PM-z","promoMessage":"QM-z","appliedPromoMessage":"RM-z","promoMessageAmount":"SM-z"};